<template>
  <div class="d-flex justify-center flex-wrap flex-gap-8 fxspot-controls">
    <div>
      <span class="light-input-text">{{ $t("quoteInfo.side") }}</span>
      <v-radio-group
        v-model="side"
        class="mt-0"
        @change="onEmitChanges"    
        row
        mandatory
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio class="radio-label" :label="$t('quoteInfo.buy').toUpperCase()" value="BUY">
        </v-radio>
        <v-radio class="radio-label"  :label="$t('quoteInfo.sell').toUpperCase()" value="SELL">
        </v-radio>
      </v-radio-group>
    </div>
    <div>
      <span class="light-input-text">{{ $t("quoteInfo.parity") }}</span>
      <v-radio-group
        v-model="ccy"
        class="mt-0"
        @change="onEmitChanges"        
        mandatory
        row
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio class="radio-label"  label="USDBRL" value="USD"> </v-radio>
        <v-radio class="radio-label"  label="EURBRL" value="EUR"> </v-radio>
        <v-radio class="radio-label"  label="JPYBRL" value="JPY"> </v-radio>
        <v-radio  class="radio-label"  label="GBPBRL" value="GBP"> </v-radio>
      </v-radio-group>
    </div>
    <!--settlement or maturity-->
    <div>
      <span class="light-input-text">{{ $t("quoteInfo.settlement") }}</span>
      <v-radio-group
        v-model="settlement"
        @change="onEmitChanges" 
        class="mt-0"
        mandatory
        row
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio class="radio-label"  label="D+0" value="d+0"> </v-radio>
        <v-radio class="radio-label"  label="D+1" value="d+1">  </v-radio>
        <v-radio class="radio-label"  label="D+2" value="d+2"> </v-radio>
      </v-radio-group>
    </div>
    <!--operations
    <div>
      <span>Operations</span>
      <v-select  
                :key="operationsList.id"
                disabled
                item-text="alias"
                item-value="id"
                return-object 
                @change="onEmitChanges" v-model="operation"  dense/>
    </div>-->
  </div>
</template>

<script>
import { useExecutionStore } from '@/store';
import { mapActions } from 'pinia';
export default {
  props: ["loadingNewRfq", "gridActive",],
  emits: ["ccy", "side", "settlement"],
  data() {
    return {
      side: "BUY",
      ccy: "USD",
      settlement: "d+0",
      operation: undefined,
      operationsList: [],
      namedOperationsList: []
    };
  },
  mounted() {
    this.onEmitChanges();
  },
  watch: {
    operationList: {
      /*
      async handler (newVal) {
        this.operationsList = newVal
        const results = await Promise.all(newVal.map(op=>this.getCompanyById(op.companyId)))
        this.namedOperationsList = newVal.map((op,id)=>({
          ...op,
          companyName: results[id]?.data?.name || '-'
        }))
        this.namedOperationsList = this.namedOperationsList.filter(op=>op.rfqId === null && op.amlCheck)
      },
      deep: true
      */
    },
  },
  methods: {
    ...mapActions(useExecutionStore, [ 'getCompanyById']),
    onEmitChanges(){
      const ready = this.side && this.ccy && this.settlement;
      
      if(!ready) return;

      this.$emit("change",{
        side: this.side,
        ccy: this.ccy,
        settlement: this.settlement
      })
    },
    onSettlementChange(val) {
      this.$emit("settlement", val);
    },
    onSideChange(val) {
      this.$emit("side", val);
    },
    onCurrencyChange(val) {
      this.$emit("ccy", val);
    },
    onOperationChange(val)
    {
      //this.$emit('operation', val)
    }
  },
  computed:{
    operationListNotSynced(){
      return this.operationList.filter(op=>op.rfqId === null)
    }
  }
};
</script>
<style scoped>
.fxspot-controls {
  gap: clamp(0.75rem, 3vw, 2rem);
}
@media (max-width: 599px) {
  .fxspot-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}


</style>
